import api from "../../../services/api";

export const getLicenseInfo = () => {
  return api.get("/license");
};
